import { render, staticRenderFns } from "./IconSubtitle.vue?vue&type=template&id=5d0a31b4"
import script from "./IconSubtitle.vue?vue&type=script&lang=ts"
export * from "./IconSubtitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports